import React from 'react';
import s from './Paragraph.styles';
const Paragraph = ({ children, className, size = 'regular', align = 'left', isLatestNewsWidget, }) => {
    return (React.createElement(s.Paragraph, { className: className, size: size, align: align, isLatestNewsWidget: isLatestNewsWidget }, children));
};
export default Paragraph;
